module.exports = __webpack_public_path__ + "assets/images/CAD10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CAD10.png
// module id = 1326
// module chunks = 1